import React from 'react';
import PolicyLayout from './PolicyLayout';

const TermsOfUse = () => (
  <PolicyLayout title="Terms of Use" updated="14 September 2026">
    <h2>1. Acceptance of these Terms</h2>
    <p>
      These Terms of Use ("Terms") govern access to and use of the
      Project Green Intranet portal ("the Portal") by employees,
      officers, contractors, and other personnel of Project Green ("the
      Company") who have been granted access credentials ("Authorised
      Users", "you", or "your"). By accessing or using the Portal, you
      acknowledge that you have read, understood, and agree to be bound
      by these Terms. If you do not agree to these Terms, you must not
      access or use the Portal.
    </p>

    <h2>2. Access and Authorisation</h2>
    <p>
      Access to the Portal is granted solely to Authorised Users by
      means of credentials issued through the Company's identity
      management system (Azure Active Directory). Your access
      credentials are personal to you and must not be shared, disclosed,
      or transferred to any other person. You are responsible for all
      activity conducted under your account and must notify the
      Company's IT department promptly upon becoming aware of any
      unauthorised use.
    </p>

    <h2>3. Acceptable Use</h2>
    <p>You agree that you shall not, in connection with your use of the Portal:</p>
    <ul>
      <li>use the Portal for any unlawful, fraudulent, or improper purpose;</li>
      <li>attempt to obtain unauthorised access to any account, system, or database connected to the Portal, including any third-party service integrated with it;</li>
      <li>employ any automated means, including scripts, bots, or scraping tools, to extract or aggregate data from the Portal or any connected system;</li>
      <li>introduce or transmit any virus, malware, or other code designed to disrupt or damage the Portal or connected systems;</li>
      <li>interfere with, disable, or circumvent any security or access-control feature of the Portal;</li>
      <li>disclose, publish, or distribute confidential or internal-only content accessible through the Portal to any person outside the Company, save where expressly authorised to do so.</li>
    </ul>

    <h2>4. Confidentiality of Content</h2>
    <p>
      All documents, records, directories, and other content made
      available through the Portal are confidential and are provided
      solely for the internal use of Authorised Users in the performance
      of their duties. Such content must not be reproduced, forwarded,
      or otherwise disclosed outside the Company except with the prior
      authorisation of the relevant department or the Data Protection
      Officer, as applicable.
    </p>

    <h2>5. Availability of the Portal</h2>
    <p>
      The Company will use reasonable efforts to maintain the
      availability of the Portal but does not warrant that it will be
      available on an uninterrupted or error-free basis. The Company
      reserves the right to suspend, restrict, or withdraw access to the
      Portal, in whole or in part, for maintenance, security, or other
      operational reasons, with or without prior notice.
    </p>

    <h2>6. Reliance on Content</h2>
    <p>
      Content made available on the Portal is provided for general
      internal informational purposes. Where a conflict arises between
      content on the Portal and an official policy, procedure, or
      contractual document of the Company, the latter shall prevail.
    </p>

    <h2>7. Limitation of Liability</h2>
    <p>
      To the maximum extent permitted by applicable law, the Company
      shall not be liable for any loss or damage arising from your use
      of, or inability to use, the Portal, including any loss arising
      from unavailability, error, or reliance on content contained
      within it, save to the extent such liability cannot lawfully be
      excluded or limited.
    </p>

    <h2>8. Amendments to these Terms</h2>
    <p>
      The Company reserves the right to amend these Terms at its
      discretion. The continued use of the Portal following the
      publication of amended Terms constitutes acceptance of those
      Terms. You are advised to review this page periodically.
    </p>

    <h2>9. Governing Law</h2>
    <p>
      These Terms shall be governed by, and construed in accordance
      with, the laws of Malta.
    </p>

    <h2>10. Contact</h2>
    <div className="policy-contact-box">
      <p>Queries regarding these Terms may be directed to IT Support via the Report an Issue form, or to:</p>
      <p>Email: info@projectgreen.mt</p>
    </div>
  </PolicyLayout>
);

export default TermsOfUse;